module.exports = __webpack_public_path__ + "img/wallet-widget-background-2.44d2c3c4.png";